<template>
    <van-overlay :show="adShow">
        <div class="ad-overlay-wrapper">
            <div class="ad-overlay-wrapper-image" @click="adJump()">
                <img v-if="screen_advert && screen_advert.length" :src="screen_advert && screen_advert.length ? screen_advert[0].cover_img : ''" alt="" />
            </div>
            <div class="ad-overlay-wrapper-close">
                <img src="/static/img/course/icon_popup_close.svg" @click="adShow = false" />
            </div>
        </div>
    </van-overlay>
</template>

<script>
import Interface from '@/util/interface'
export default {
    data() {
        return {
            screen_advert: [],
            adShow: false
        }
    },
    created() {
        this.fetch('homepage')
    },
    methods: {
        fetch(scene) {
            if (scene === 'homepage') {
                Interface.getData('get', Interface.home).then(res => {
                    this.screen_advert = res.data.screen_advert ? res.data.screen_advert : []
                    this.setAdShow()
                })
            }
        },
        // 设置广告1天展示一次
        setAdShow() {
            if (this.screen_advert.length == 0) {
                return
            }
            let start_time = new Date(this.screen_advert[0].start_time).getTime()
            let end_time = new Date(this.screen_advert[0].end_time).getTime()
            let current_time = new Date().getTime()
            if (current_time > end_time || current_time < start_time) {
                return
            }
            let flag = false

            // 读取cookie
            if (document.cookie && document.cookie.length) {
                let cookieArr = document.cookie.split(';')
                for (let i = 0; i < cookieArr.length; i++) {
                    let arr = cookieArr[i].split('=')
                    if (arr[0].trim().includes('firstEnter')) {
                        flag = true
                    }
                }
            }

            if (!flag) {
                let curDate = new Date()
                let curTamp = curDate.getTime()
                // 当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
                // toLocaleDateString() 根据本地时间格式，把 Date 对象的日期部分转换为字符串。
                // 如：会把Thu May 21 2020 20:41:59 GMT+0800 (中国标准时间)  转换成  2020/5/21
                let curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1
                // 当日已经过去的时间（毫秒）
                let passedTamp = curTamp - curWeeHours
                // 当日剩余时间  一天共有24 * 60 * 60 * 1000 = 86,400,000毫秒
                let leftTamp = 24 * 60 * 60 * 1000 - passedTamp
                let leftTime = new Date()

                leftTime.setTime(leftTamp + curTamp)
                // 创建cookie
                document.cookie = 'firstEnter=have' + ';expires=' + leftTime.toUTCString()

                this.adShow = true
            }
        },
        adJump() {
            if (this.screen_advert && this.screen_advert.length > 0) {
                Interface.getData('get', Interface.course.ad_click + '/' + this.screen_advert[0].id + '/view').then(res => {
                    // console.log('===', res.data)
                })
                location.href = this.screen_advert[0].link
            }
        }
    }
}
</script>

<style lang="scss">
.ad-overlay-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    &-image {
        width: 315px;
        height: 400px;
        background: #d8d8d8;
        border-radius: 12px;
        img {
            width: inherit;
            height: inherit;
            border-radius: 12px;
        }
    }
    &-close {
        margin-top: 16px;
        text-align: center;
        img {
            width: 40px;
            height: 40px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/advertisement.vue